var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "#F4F4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6666V41.3333C20 44.268 22.392 45.3333 24 45.3333H44V42.6666H24.016C23.4 42.6506 22.6667 42.408 22.6667 41.3333C22.6667 40.2586 23.4 40.016 24.016 40H44V21.3333C44 19.8626 42.804 18.6666 41.3333 18.6666H24C22.392 18.6666 20 19.732 20 22.6666V26.6666ZM24 21.3333H41.3333V37.3333H22.6667V22.6666C22.6667 21.592 23.4 21.3493 24 21.3333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.996 34.6667L36.4627 30.2814C36.7381 30.0165 36.9572 29.6988 37.1068 29.3472C37.2565 28.9956 37.3336 28.6175 37.3336 28.2354C37.3336 27.8533 37.2565 27.4751 37.1068 27.1235C36.9572 26.772 36.7381 26.4542 36.4627 26.1894C35.9075 25.6414 35.1588 25.3341 34.3787 25.3341C33.5986 25.3341 32.8499 25.6414 32.2947 26.1894L31.996 26.48L31.6973 26.188C31.1424 25.6401 30.3939 25.3329 29.614 25.3329C28.8341 25.3329 28.0857 25.6401 27.5307 26.188C27.2553 26.4529 27.0362 26.7706 26.8865 27.1222C26.7369 27.4738 26.6597 27.8519 26.6597 28.234C26.6597 28.6161 26.7369 28.9943 26.8865 29.3459C27.0362 29.6974 27.2553 30.0152 27.5307 30.28L31.996 34.6667Z",
    fill: "#11B55F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookChat);
export default __webpack_public_path__ + "static/media/bookChat.9d38a9dab8ab1f962e615b1c61589084.svg";
export { ForwardRef as ReactComponent };